/**
 * Type guard ensuring a value is an object record before property access.
 * Excludes arrays and null values.
 *
 * @param value - The value to check.
 * @returns True if the value is a non-null, non-array object.
 */
export const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}
